/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {agentWhoami} from '../api'

export const useMutationAgentWhoami = createReactQueryMutationHook('agentWhoami', agentWhoami)
